// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function CityVehicleCmp(Props) {
  var vehicle_name = Props.vehicle_name;
  var geo_region = Props.geo_region;
  return React.createElement("div", {
              className: "vehicle-and-city-container"
            }, React.createElement("p", {
                  className: "vehicle"
                }, vehicle_name.toUpperCase()), React.createElement("p", {
                  className: "city"
                }, geo_region.toUpperCase()));
}

var make = CityVehicleCmp;

export {
  make ,
  
}
/* react Not a pure module */
